import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { FaRegEnvelope } from 'react-icons/fa'
import { baseURL } from '../../../Utils/constants/constant'
import imgs from "../../../Utils/assets/img/faces/5.jpg"
import { IconPhone } from '@tabler/icons-react'
import { getCountryCallingCode } from 'libphonenumber-js/min'
import { Dropdown, Nav } from 'react-bootstrap'
import { toast } from 'sonner'
import useLocalStorageState from 'use-local-storage-state'
import { maskContactNumber, navigateToCrmDetail } from '../../../Utils/helpers/commonhelper'
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'
import { useLocation } from 'react-router-dom'

export const ContactInfoCard = ({
    contact,
    // customer,
    // setShowContactDetailsCanvas,
    setActiveCard,
    setShowDeleteModal,
    setConfirmDeleteId,
    // setContactId,
    setShowId,
    contactIds
}) => {
    const { customer, navigate } = useGetEssentials()
    const location = useLocation()
    const [PERMISSION, _] = useLocalStorageState('permission')
    const contactPermission = PERMISSION?.contact;
    const data = contact?.phone

    return (
        <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <div
                className="card custom-card"
                key={contact.id}
                style={{
                    boxShadow:
                        "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    animation: "cardEntry 1s ease-out forwards",
                    padding: "10px 7px",
                }}
            >
                <div
                    className="card-body contact-action w-100"
                    style={{ padding: "13px 10px" }}
                >
                    <div className="d-flex align-items-top ">
                        <div className="d-flex flex-fill gap-3">
                            <div
                                className="avatar avatar-xl avatar-rounded"
                            >
                                <img
                                    src={
                                        !contact?.contact_image
                                            ? imgs
                                            : `${baseURL}${contact?.contact_image}`
                                    }
                                    alt=""
                                />
                            </div>
                            <div style={{ width: "70%" }}>
                                <h6
                                    className="mb-1 fw-semibold"
                                    onClick={(e) => {
                                        // setContactId(contact?.id)
                                        // setShowContactDetailsCanvas(true)

                                        navigateToCrmDetail(
                                            navigate,
                                            location,
                                            `/contactDetails?currContactId=${contact?.id}`,
                                            { contactIds },
                                        )
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        textTransform: "capitalize",
                                        fontWeight: 300
                                    }}
                                >
                                    {contact?.contact_full_name?.length > 20 ? `${contact?.contact_full_name?.slice(0, 24)}...` : contact?.contact_full_name}
                                </h6>
                                <p
                                    className="mb-1 text-muted contact-mail text-truncate"
                                    style={{
                                        width: " 100%",
                                        fontSize: "12px",
                                        minWidth: "100%",
                                    }}
                                >
                                    {" "}
                                    <FontAwesomeIcon
                                        icon={FaRegEnvelope}
                                    />{" "}
                                    {contact?.email}
                                </p>
                                <p className="fw-semibold fs-12 mb-0 text-primary">
                                    <IconPhone style={{ width: "14px" }} />
                                    <span
                                        style={{
                                            fontFamily: "monospace",
                                            letterSpacing: "1px",
                                            whiteSpace: "nowrap",
                                        }}>
                                        {" "}
                                        +
                                        {getCountryCallingCode(contact?.countryCode || 'IN')}
                                        {" "}
                                        {maskContactNumber(customer, data, "Mobile")}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <Dropdown
                            as="div"
                            className="dropdownsWithoutToggle"
                        >
                            <Dropdown.Toggle
                                as={Nav.Link}
                                className="header-link"
                            >
                                <FontAwesomeIcon
                                    icon={faEllipsisVertical}
                                    style={{
                                        fontSize: "15px",
                                        width: "20px",
                                        color: "#536485",
                                    }}
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                // className="defaultDropdown"
                                align={"end"}
                                style={{
                                    width: "8rem",
                                    inset: "0px auto auto 0px",
                                    boxShadow:
                                        "rgb(215, 215, 215) 0px 0px 15px",
                                    position: "absolute",
                                    marginTop: "-6px",
                                    minWidth: "3rem",
                                }}
                                className='p-0 py-1'
                            >
                                <Dropdown.Item
                                    style={{
                                        fontSize: "12px",
                                        padding: "0px 21px",
                                    }}
                                    className="d-flex align-items-center"
                                    onClick={(e) => {
                                        if (!contactPermission?.isEdit) {
                                            toast.warning(
                                                "You are not authorized for this action!",
                                            )
                                            return
                                        }
                                        e.stopPropagation()
                                        setShowId(contact.id)
                                        setActiveCard(null)
                                    }}
                                >
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                    style={{
                                        fontSize: "12px",
                                        padding: "4px 21px",
                                    }}
                                    onClick={(e) => {
                                        if (!contactPermission?.isDelete) {
                                            toast.warning(
                                                "You are not authorized for this action!",
                                            )
                                            return
                                        }
                                        e.stopPropagation()
                                        setShowDeleteModal(true)
                                        setConfirmDeleteId(contact.id)
                                        setActiveCard(null)

                                    }}
                                    className="d-flex align-items-center"
                                >
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div >
    )
}
